import React from "react";
import { Button } from "antd";

const ThankYouScreen = ({onContinue}) => (
  <div style={{ textAlign: "center", padding: "50px" }}>
    <h1 style={{ color: "#4CAF50", marginBottom: "20px" }}>
      Thank you for completing your Business Profile!
    </h1>
    <p style={{ fontSize: "18px", maxWidth: "600px", margin: "0 auto" }}>
      You can expect outreach from a matched provider within 2–3 business days via your preferred contact method.
    </p>
    <p style={{ fontSize: "16px", marginTop: "15px" }}>
      If you have questions, email us at{" "}
      <a href="/app/Contact">contact@mediapiq.com</a>.
    </p>
    <br />
    <Button type="primary" style={{ marginTop: 20 }} onClick={onContinue}>
      View Matched Companies
    </Button>
  </div>
);

export default ThankYouScreen;
